import { render, staticRenderFns } from "./microLecture.vue?vue&type=template&id=f6dd3f26&"
import script from "./microLecture.vue?vue&type=script&lang=js&"
export * from "./microLecture.vue?vue&type=script&lang=js&"
import style0 from "./microLecture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports